import React from 'react';
import self from '../assets/images/self.svg';
const Hero=()=>{
    return(
        <section className="hero" id="home">
            <img src={self} alt="Amit Singh" className="hero__img" />
            <h1 className="hero__heading">
                Hey !<br/>I am<br/> Amit Singh.
            </h1>
            <h2 className="hero__sub-heading">
                Living, learning, &amp; leveling up one day at a time.
            </h2>
        </section>
    );
};

export default Hero;